module.exports = __webpack_public_path__ + "img/toGet.1775439203884.png";